import * as React from 'react';
import l10n = require('diy/util/l10n');

import {ToolbarGroup} from './toolbar/ToolbarGroup';
import {ToolbarContent} from './toolbar/ToolbarContent';
import {Dropdown} from './toolbar/Dropdown';

import {SelectableList} from './advanced/SelectableList';

import {AvailableStyles, Preset, RoundnessStyle, ExtrasStyle} from '../data/styles';
import {StyleSettings} from '../data/styles';

import StyleIcon from 'material-ui/svg-icons/maps/layers';
import RoundnessIcon from 'material-ui/svg-icons/action/rounded-corner';
import DecorationIcon from 'material-ui/svg-icons/image/photo-filter';

export interface StateProps {
    availableStyles: AvailableStyles;
    style: StyleSettings;
}

export interface DispatchProps {
    onPresetSelect?(preset: Preset): void;
    onPresetPreview?(preset: Preset): void;
    onRoundnessSelect?(roundness: RoundnessStyle): void;
    onRoundnessPreview?(roundness: RoundnessStyle): void;
    onExtrasSelect?(extras: ExtrasStyle): void;
    onExtrasPreview?(extras: ExtrasStyle): void;
}

interface AdvancedViewProps extends StateProps, DispatchProps {

}

export class AdvancedView extends React.Component<AdvancedViewProps, {}> {
    render() {
        let styles = this.getStyles();
        return (
            <ToolbarContent>
                <ToolbarGroup>
                    <Dropdown
                        text={l10n.getString('section.actionBar.buttons.styleSettings.label')}
                        Icon={<StyleIcon/>}
                        layerStyle={{
                            width: 250
                        }}
                        dataTestId="section-style"
                    >
                        <SelectableList
                            items={this.props.availableStyles.presets}
                            selectedItem={this.props.style.preset}
                            onItemSelect={this.props.onPresetSelect}
                            onPreviewedItemChange={this.props.onPresetPreview}
                            title={l10n.getString('section.stylePresets.title')}
                            titleStyle={styles.title}
                            dataTestId="section-presets"
                            style={styles.list}
                        />
                    </Dropdown>
                    <Dropdown
                        text={l10n.getString('section.actionBar.buttons.roundnessSettings.label')}
                        Icon={<RoundnessIcon/>}
                        layerStyle={{
                            width: 250
                        }}
                        dataTestId="section-style-roundness"
                    >
                        <SelectableList
                            items={this.props.availableStyles.roundness}
                            selectedItem={this.props.style.roundness}
                            onItemSelect={this.props.onRoundnessSelect}
                            onPreviewedItemChange={this.props.onRoundnessPreview}
                            title={l10n.getString('section.roundnessSettings.title')}
                            titleStyle={styles.title}
                            dataTestId="section-cornersets"
                            style={styles.list}
                        />
                    </Dropdown>
                    <Dropdown
                        text={l10n.getString('section.actionBar.buttons.extrasSettings.label')}
                        Icon={<DecorationIcon/>}
                        layerStyle={{
                            width: 250
                        }}
                        dataTestId="section-style-decoration"
                    >
                        <SelectableList
                            items={this.props.availableStyles.extras}
                            selectedItem={this.props.style.extras}
                            onItemSelect={this.props.onExtrasSelect}
                            onPreviewedItemChange={this.props.onExtrasPreview}
                            title={l10n.getString('section.extrasSettings.title')}
                            titleStyle={styles.title}
                            dataTestId="section-extras"
                            style={styles.list}
                        />
                    </Dropdown>
                </ToolbarGroup>
            </ToolbarContent>
        );
    }

    private getStyles() {
        return {
            title: {
                fontFamily: "open sans",
                fontSize: '14px',
                lineHeight: '14px',
                margin: 10,
                color: '#666'
            },
            list: {
                paddingTop: 0
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/AdvancedView.tsx
 **/